import { TFuncKey } from "react-i18next";

import { documentToImagesMap } from "pages/AdditionalDocuments/documentToImages";

import { CarIcon } from "components/Icons/CarIcon";
import { KeysIcon } from "components/Icons/KeysIcon";

import { GridImageDocument } from "../PhotoGrid/types";

export type ChecklistItemVariant = "yourVehicle" | "vehicleKeys" | GridImageDocument;

type ItemInfo = {
  text: TFuncKey<"default">;
  icon?: () => JSX.Element;
};

export const checklistItemVariants: Record<ChecklistItemVariant, ItemInfo> = {
  yourVehicle: {
    text: "onboarding.checklist.vehicle",
    icon: CarIcon,
  },
  vehicleKeys: {
    text: "onboarding.checklist.vehicle_keys",
    icon: KeysIcon,
  },
  itAccidentCircumstance: { text: documentToImagesMap["itAccidentCircumstance"][0].caption },
  itRegistrationCertificate: { text: documentToImagesMap["itRegistrationCertificate"][0].caption },
  jpCarCertificate: { text: "onboarding.checklist.jpCarCertificate" },
  plAccidentDocument: { text: documentToImagesMap["plAccidentDocument"][0].caption },
  plCarRegistrationCertificate: { text: "onboarding.checklist.plCarRegistrationCertificate" },
  plDriversLicense: { text: "onboarding.checklist.plDriversLicense" },
  plAccidentStatement: { text: documentToImagesMap["plAccidentStatement"][0].caption },
  link4AccidentStatement: { text: documentToImagesMap["link4AccidentStatement"][0].caption },
};
